import React, { useContext, useState, useEffect } from "react";
import { AuthContext } from '../../context/AuthContext'
import GoogleButton from 'react-google-button'
import Loader from "../common/Loader";
import { useNavigate } from "react-router-dom";


function Home() {
    const { login, user } = useContext(AuthContext);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (isLoading) {
            setIsLoading(false);
        }
      }, [user]);

    if (user && user !== 'null') {
        navigate("/calendario");
    }

    return (
        <div className="home">
            {isLoading ? (
                <div className="login">
                    <Loader/>
                </div>
            ) : (
                <div className="loginContainer">
                    <div className="qualtio-logo">
                        <img alt="logo" src="../../logo-qualtio.png" height="100px"/>
                    </div>
                    <div className="button">
                        <GoogleButton
                            type="light"
                            onClick={() => {
                                setIsLoading(true);
                                login();
                            }}
                        />
                    </div>
                </div>
            )}
        </div>      
        );
}

export default Home;